import Glider from 'glider-js';

const isMobile = window.matchMedia('(max-width: 767px)').matches;

// Initialize Glider.js for toplists
window.addEventListener('load', function () {
	document.querySelectorAll('.toplist-slider .glider').forEach((elem) => {
		new Glider(elem, {
			slidesToShow: 'auto',
			slidesToScroll: 'auto',
			itemWidth: 288,
			skipTrack: true,
			draggable: true,
			resizeLock: false,
			exactWidth: true,
			dragVelocity: 1,
			duration: 1,
		});
	});
});

// Update more payment methods count for mobile in horizontal toplists
document.querySelectorAll('.toplist--horizontal .cta-card').forEach((card) => {
	const pmMore = card.querySelector('.pm-item--more');
	if (isMobile && pmMore) {
		const moreCount = +pmMore.textContent + 2;
		pmMore.textContent = `+${moreCount}`;
	}
});